import React from 'react';

const TemplateFormModal = ({ 
  isOpen, 
  onClose, 
  onSubmit, 
  title,
  formData,
  validationErrors,
  formSubmitting,
  onFormChange,
  onVariableChange,
  onAddVariable,
  onRemoveVariable
}) => {
  if (!isOpen) return null;

  return (
    <div
      className={`template-modal-overlay ${isOpen ? "visible" : ""}`}
    >
      <div 
        className="template-modal-container template-form-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="template-modal-header">
          <h3 className="template-modal-title">{title}</h3>
          <button
            className="template-modal-close"
            onClick={onClose}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
        
        <form onSubmit={onSubmit}>
          <div className="template-modal-body">
            <div className="template-form-grid">
              <div className="template-form-group">
                <label className="template-form-label" htmlFor="name">Template Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className={`template-form-input ${validationErrors.name ? 'error' : ''}`}
                  value={formData.name}
                  onChange={onFormChange}
                  required
                  readOnly={title !== "Create New Template"}
                  disabled={title !== "Create New Template"}
                />
                {validationErrors.name && (
                  <div className="template-form-error">{validationErrors.name}</div>
                )}
                <small className="template-form-help">Only lowercase letters, numbers, and underscores allowed</small>
              </div>
              
              <div className="template-form-group">
                <label className="template-form-label" htmlFor="category">Category *</label>
                <select
                  id="category"
                  name="category"
                  className={`template-form-select ${validationErrors.category ? 'error' : ''}`}
                  value={formData.category}
                  onChange={onFormChange}
                  required
                >
                  <option value="UTILITY">UTILITY</option>
                  <option value="MARKETING">MARKETING</option>
                  <option value="TRANSACTIONAL">TRANSACTIONAL</option>
                </select>
                {validationErrors.category && (
                  <div className="template-form-error">{validationErrors.category}</div>
                )}
              </div>
              
              <div className="template-form-group template-form-full">
                <label className="template-form-label" htmlFor="body">Template Body *</label>
                <textarea
                  id="body"
                  name="body"
                  className={`template-form-textarea ${validationErrors.body ? 'error' : ''}`}
                  value={formData.body}
                  onChange={onFormChange}
                  rows="5"
                  required
                ></textarea>
                {validationErrors.body && (
                  <div className="template-form-error">{validationErrors.body}</div>
                )}
                <small className="template-form-help">{`Use {{variable}} syntax for dynamic content`}</small>
              </div>
              
              <div className="template-form-group template-form-full">
                <label className="template-form-label">Variables</label>
                {formData.variables.map((variable, index) => (
                  <div key={index} className="template-variable-row">
                    <input
                      type="text"
                      placeholder="Variable name *"
                      className="template-form-input"
                      value={variable.name}
                      onChange={(e) => onVariableChange(index, 'name', e.target.value)}
                      required
                    />
                    <input
                      type="text"
                      placeholder="Sample value *"
                      className="template-form-input"
                      value={variable.sampleValue}
                      onChange={(e) => onVariableChange(index, 'sampleValue', e.target.value)}
                      required
                    />
                    <button 
                      type="button" 
                      className="template-variable-remove"
                      onClick={() => onRemoveVariable(index)}
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                ))}
                {validationErrors.variables && (
                  <div className="template-form-error">{validationErrors.variables}</div>
                )}
                <button 
                  type="button" 
                  className="template-variable-add"
                  onClick={onAddVariable}
                >
                  <i className="fas fa-plus"></i> Add Variable
                </button>
                <small className="template-form-help">Add variables if your template uses dynamic content with {`{{variable}}`} syntax</small>
              </div>
            </div>
          </div>
          
          <div className="template-modal-footer">
            <button
              type="button"
              className="template-modal-button secondary"
              onClick={onClose}
              disabled={formSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="template-modal-button"
              disabled={formSubmitting}
            >
              {formSubmitting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {title === "Create New Template" ? "Creating..." : "Updating..."}
                </>
              ) : (
                title === "Create New Template" ? "Create Template" : "Update Template"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TemplateFormModal; 